import React from 'react';
import { Grid, Hidden } from '@mui/material';
import SubMenuCard from './SubMenuCard';
var _ = require('lodash');
import MenuLoadingSkeleton from "../../skeletons/MenuLoadingSkeleton";


const SubMenu = ({ data, rootURL, label, loading }) => {
  if (_.isEmpty(data) == true && loading == true) return <MenuLoadingSkeleton variant={"rectangular"} marginx={1} marginy={1} count={5} height={48} />;
  data = _.orderBy(data, ['order'], ['asc'])
  return (
    <React.StrictMode>
      <Grid item md={1.5} lg={1.5}>
        <Hidden mdDown>
          <SubMenuCard data={data} label={label} rootURL={rootURL} />
        </Hidden>
      </Grid>
    </React.StrictMode>
  )
};

export default SubMenu;
